var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export default function search(data, searchKey, searchState) {
    return __spreadArray([], __read(data), false).filter(function (e) {
        var _a;
        return (_a = e[searchKey]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchState.trim().toLowerCase());
    });
}
export var searchInArrayObject = function (data, searchValue) {
    return data.filter(function (obj) { return searchInObject(obj, searchValue); });
};
export var searchInObject = function (data, searchValue) {
    if (data)
        return Object.keys(data).some(function (key) {
            var _a;
            if (((typeof data[key] === "string" ||
                typeof data[key] === "number") &&
                (new RegExp("(?:^|\\s)" + searchValue, "i").test(data[key]) ||
                    data[key] ==
                        searchValue)) ||
                (typeof data[key] === "string" &&
                    key == "displayName" &&
                    ((_a = data[key]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue.toLowerCase())))) {
                return true;
            }
            else if (typeof data[key] === "object") {
                return searchInObject(data[key], searchValue);
            }
            else {
                return false;
            }
        });
};
export var searchMultipleKeys = function (data, searchKey, searchState) {
    var regex = new RegExp(searchState);
    var output = data.filter(function (e) {
        return searchKey.some(function (k) {
            var _a, _b;
            return (_b = (_a = e[k]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchState === null || searchState === void 0 ? void 0 : searchState.toLocaleLowerCase());
        });
    });
    return output;
};
export var findObjectsByValue = function (arr, searchString) {
    return arr.filter(function (obj) {
        return Object.values(obj).some(function (value) {
            if (typeof value === "string") {
                return value.toLowerCase().includes(searchString.toLowerCase());
            }
            else if (typeof value === "number" || typeof value === "boolean") {
                return String(value).includes(searchString);
            }
            else if (typeof value === "object" && value !== null) {
                return findObjectsByValue([value], searchString).length > 0;
            }
            return false;
        });
    });
};
